(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('turnstileSvc', ['$q', turnstileSvc]);

    function turnstileSvc($q) {
        var isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        var TURNSTILE_SITE_KEY = isLocalhost ? '1x00000000000000000000AA' : '0x4AAAAAACNleg3E3Cw7A_b0';
        var scriptLoaded = false;

        function getToken() {
            var deferred = $q.defer();

            if (!window.turnstile && !scriptLoaded) {
                var script = document.createElement('script');
                script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
                script.async = true;
                script.onload = function () {
                    scriptLoaded = true;
                    renderWidget(deferred);
                };
                script.onerror = function () { deferred.resolve(null); };
                document.head.appendChild(script);
            } else {
                renderWidget(deferred);
            }

            return deferred.promise;
        }

        function renderWidget(deferred) {
            var container = document.getElementById('turnstile-invisible-container');
            if (!container) {
                container = document.createElement('div');
                container.id = 'turnstile-invisible-container';
                container.style.position = 'fixed';
                container.style.top = '-9999px';
                container.style.left = '-9999px';
                container.style.width = '1px';
                container.style.height = '1px';
                container.style.overflow = 'hidden';
                document.body.appendChild(container);
            }
            container.innerHTML = '';

            try {
                window.turnstile.render(container, {
                    sitekey: TURNSTILE_SITE_KEY,
                    size: 'normal',
                    callback: function (token) { deferred.resolve(token); },
                    'error-callback': function () { deferred.resolve(null); }
                });
            } catch (e) {
                deferred.resolve(null);
            }
        }

        return { getToken: getToken };
    }
})();
